import {Server} from './server';

export const newsServer = new Server(process.env.REACT_APP_NEWS_SERVER_URL);
export const employmentServer = new Server(process.env.REACT_APP_EMPLOYMENT_SERVER_URL);

